module.exports = __webpack_public_path__ + "spring.3455cc.svg";